import styled from 'styled-components'

export const Container = styled.div``

export const Code = styled.div`
  color: ${({ theme }) => theme.cor9};
`
